(function () {
  $(document).on("turbolinks:load", function () {
    setTimeout( function() {
      $('.l-sidebar').attr('style','');
    },1000);
  });
})();
